import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Card, Column, Divider, Row, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { utils } from '~/utils';
import { scheduledInvoiceColumnsTextsPath } from '../ScheduledInvoice.utils';
export const GetLineItemMobileCardTID = (parentTestId)=>getTestIds(parentTestId);
export function LineItemMobileCard(param) {
    let { charge, testId, statusBadge } = param;
    var _charge_subLineItems;
    const { LineItemMobileCardTestIds: TID } = useMemo(()=>GetLineItemMobileCardTID(testId), [
        testId
    ]);
    const { t: columnsTexts } = useLocaleKeys(scheduledInvoiceColumnsTextsPath);
    const { t: lineItemTexts } = useLocaleKeys('pages.agreementMinisite.scheduledInvoice.lineItem');
    const subLineItems = (_charge_subLineItems = charge.subLineItems) !== null && _charge_subLineItems !== void 0 ? _charge_subLineItems : [];
    const hasSubLineItems = subLineItems.length > 0;
    return /*#__PURE__*/ _jsx(Card, {
        bi: {
            name: 'scheduled_invoice_line_item_mobile_card'
        },
        padding: "m",
        borderRadius: "m",
        skin: "mobileGray",
        testId: testId,
        children: /*#__PURE__*/ _jsxs(Column, {
            gap: 12,
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    gap: 8,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            weight: "bold",
                            variant: "h6",
                            testId: TID.Name(),
                            children: charge.name
                        }),
                        statusBadge
                    ]
                }),
                hasSubLineItems && /*#__PURE__*/ _jsx(Column, {
                    gap: 12,
                    children: subLineItems.map((sub, idx)=>/*#__PURE__*/ _jsxs(Column, {
                            gap: 2,
                            children: [
                                /*#__PURE__*/ _jsxs(Row, {
                                    gap: 8,
                                    justifyContent: "space-between",
                                    alignItems: "baseline",
                                    children: [
                                        /*#__PURE__*/ _jsx(Typography, {
                                            testId: TID.SubLineItemName(idx),
                                            children: sub.name
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            children: utils.formatDollarAmount(sub.totalAmount)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    variant: "paragraph2",
                                    skin: "secondary",
                                    children: lineItemTexts.hiddenFromYourClient()
                                })
                            ]
                        }, TID.SubLineItemName(idx)))
                }),
                /*#__PURE__*/ _jsxs(Column, {
                    gap: 8,
                    children: [
                        charge.quantity != null && /*#__PURE__*/ _jsxs(Row, {
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    skin: "secondary",
                                    children: columnsTexts.quantity()
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    children: utils.formatNumberWithCommas(charge.quantity)
                                })
                            ]
                        }),
                        !hasSubLineItems && charge.rate && /*#__PURE__*/ _jsxs(Row, {
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    skin: "secondary",
                                    children: columnsTexts.rate()
                                }),
                                /*#__PURE__*/ _jsx(Typography, {
                                    children: utils.formatDollarAmount(charge.rate.amount)
                                })
                            ]
                        })
                    ]
                }),
                charge.discount && /*#__PURE__*/ _jsxs(Row, {
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            skin: "secondary",
                            children: columnsTexts.discount()
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            children: charge.discount.format()
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Divider, {
                    margin: 0,
                    skin: "white"
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    justifyContent: "space-between",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            weight: "bold",
                            children: columnsTexts.total()
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            weight: "bold",
                            testId: TID.Total(),
                            children: utils.formatDollarAmount(charge.totalAmount)
                        })
                    ]
                })
            ]
        })
    });
}
